import { render, staticRenderFns } from "./ProjectPostfundTab.vue?vue&type=template&id=050e996b&"
import script from "./ProjectPostfundTab.vue?vue&type=script&lang=js&"
export * from "./ProjectPostfundTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports